import { Link, useLocation } from 'react-router-dom';
import { useAuth } from './auth';

/**
 * Admin sub-nav bar — faithful port of the admin block in
 * `.old/resources/views/layouts/shared/horizontal-nav.blade.php`
 * (shown for users in the `admin` / `super admin` groups).
 *
 * Centered, desktop-only row with a bottom border:
 *   Admin Menu | Return to Tool | Metric Dashboard | Manage Foundries and Precast Parts
 */
export function AdminSubNav() {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const isAdmin =
    !!user && (user.roles?.includes('super-admin') || user.roles?.includes('admin'));
  if (!isAdmin) return null;

  const metricsActive = pathname.startsWith('/admin/console');
  const foundryActive = pathname.startsWith('/admin/foundries');

  return (
    <div className="container-fluid d-none d-lg-block pb-2 pt-2 mt-1 border-bottom" style={{ maxWidth: '100%' }}>
      <div className="d-flex justify-content-center align-items-center flex-wrap gap-3">
        <span className="fw-bold text-dark fs-4">Admin Menu</span>

        <img
          src="/images/ICON/Icon-Divider-Line-Black.png"
          style={{ height: 28, width: 'auto' }}
          alt=""
        />

        <Link className="link-dark text-nowrap d-inline-flex align-items-center" to="/">
          <img
            src="/images/ICON/Icon-Edit-Application.png"
            className="me-1"
            style={{ width: 25, height: 'auto' }}
            alt=""
          />
          Return to Tool
        </Link>

        <Link
          className={`link-dark text-nowrap d-inline-flex align-items-center${metricsActive ? ' text-ADStextgreen' : ''}`}
          to="/admin/console#users-report"
        >
          <img
            src="/images/ICON/Icon-Edit-Lateral-Type.png"
            className="me-1"
            style={{ width: 25, height: 'auto' }}
            alt=""
          />
          Metric Dashboard
        </Link>

        <img
          src="/images/ICON/Icon-Divider-Line-Black.png"
          style={{ height: 28, width: 'auto' }}
          alt=""
        />

        <Link
          className={`link-dark text-nowrap d-inline-flex align-items-center${foundryActive ? ' text-ADStextgreen' : ''}`}
          to="/admin/foundries"
        >
          <img
            src="/images/ICON/Icon-Find-Another-Product.png"
            className="me-1"
            style={{ width: 25, height: 'auto' }}
            alt=""
          />
          Manage Foundries and Precast Parts
        </Link>
      </div>
    </div>
  );
}
